import React from 'react';
import { formatPnL } from '@privemind/utils/formatting';
import './asset-card.scss';

interface AssetCardProps {
  name: string;
  symbol: string;
  pnl: number;
}

export const AssetCard: React.FC<AssetCardProps> = ({ name, symbol, pnl }) => {
  return (
    <div className="asset-card">
      <div className="asset-card__header">
        <h4 className="asset-card__name">{name}</h4>
        <span className="asset-card__symbol">{symbol.toUpperCase()}</span>
      </div>
      <div className="asset-card__pnl">
        <span className={`asset-card__pnl-value ${pnl >= 0 ? 'asset-card__pnl-value--positive' : 'asset-card__pnl-value--negative'}`}>
          {formatPnL(pnl)}
        </span>
      </div>
    </div>
  );
};
